import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, catchError, switchMap } from 'rxjs';

@Injectable()
export class FallbackTranslateLoader implements TranslateLoader {
  private http = inject(HttpClient);
  private remoteBase = 'https://cms-iurban.com/langs/';
  private localBase = '/assets/i18n/';

  getTranslation(lang: string): Observable<any> {
    const remoteUrl = `${this.remoteBase}${lang}.php`;
    const localUrl  = `${this.localBase}${lang}.json`;

    return this.http.get(remoteUrl).pipe(
      catchError(() => this.http.get(localUrl))
    );
  }
}